import { FormGroup } from '@angular/forms';
import { ApplianceDetailsSteppedMultiPlanForm } from './appliance-details-stepped-multi-plan-form.interface';

export type ApplianceDetailsSteppedMultiPlanFormValue = ReturnType<
  FormGroup<ApplianceDetailsSteppedMultiPlanForm>['getRawValue']
>;
